import { Document } from "~/context/Documents/domain/Document";
import { listBestMatchMovementsForDocument, listClientMovementsForDocument, listCollaboratorMovementsForDocument, listMixedMovementsFullByCompanyYearAndCriteria, listMovementsByCompanyDistanceAndCriteria, listMovementsFullByCompanyDistanceAndCriteriaWithDocument, listMovementsFullByCompanyDistanceAndCriteriaWithMovement, listMovementsFullRepositoryByCompanyAndSearch, listNearMovementsForDocument, listNearMovementsForMovement, listPreviredMovementsByCompany, listProviderMovementsForDocument } from "~/context/Movements/application/listMovements";
import { Movement } from "~/context/Movements/domain/Movement";
import { Criteria } from "~/context/Shared/domain/criteria/Criteria";
import { Filter } from "~/context/Shared/domain/criteria/Filter";
import { ExpenseDomain } from "~/context/Shared/domain/ExpenseDomain";
import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { Dependencies } from "~/context/Shared/infrastructure/Dependencies";

export function useMovementCompanyDistanceCriteria(companyId: string, documentId: string, type: string, criteria: Criteria) {
  const retMovements = listMovementsByCompanyDistanceAndCriteria(Dependencies.getInstance().getMovementRepository(), companyId, documentId, type, criteria);
  return retMovements;
}

export function useMovementCompanyDistanceCriteriaWithDocument(companyId: string, document: Document, criteria: Criteria) {

  console.log("dentro de useMovementCompanyDistanceCriteriaWithDocument: " + companyId + " criteria: " + JSON.stringify(criteria));
  // const retMovements = listMovementsByCompanyDistanceAndCriteriaWithDocument(Dependencies.getInstance().getMovementRepository(), companyId, document, criteria);
  const retMovements = listMovementsFullByCompanyDistanceAndCriteriaWithDocument(Dependencies.getInstance().getMovementRepository(), companyId, document, criteria);

  return retMovements;
}

export function useMovementCompanyDistanceCriteriaWithMovement(companyId: string, movement: Movement, criteria: Criteria) {

  console.log("dentro de useMovementCompanyDistanceCriteriaWithMovement: " + companyId + " criteria: " + JSON.stringify(criteria));
  // const retMovements = listMovementsByCompanyDistanceAndCriteriaWithDocument(Dependencies.getInstance().getMovementRepository(), companyId, document, criteria);
  const retMovements = listMovementsFullByCompanyDistanceAndCriteriaWithMovement(Dependencies.getInstance().getMovementRepository(), companyId, movement, criteria);
  //listMovementsFullByCompanyDistanceAndCriteriaWithDocument(Dependencies.getInstance().getMovementRepository(), companyId, document, criteria);

  return retMovements;
}


export async function useBestMatchesMovementsForDocument(companyId: string, documentId: string, type:string): Promise<VectiResult> {
  console.log("dentro de useBestMatchesMovementsForDocument: " + companyId + " documentId: " + documentId + " type:" + type);
  const tolerance = 0; // Valor por defecto, se puede ajustar según sea necesario
  const retDocuments = await listBestMatchMovementsForDocument(Dependencies.getInstance().getMovementRepository(), companyId, documentId, type, tolerance);
  console.log("retDocuments #-->: ", JSON.stringify(retDocuments.type?.length));
  return retDocuments;
}



export async function useMixedMovementFullCompanyYear(companyId: string, year:number,criteria: Criteria): Promise<VectiResult>  {
  console.log("(useMixedMovementFullCompanyYear): companyId: ", companyId, " criteria", JSON.stringify(criteria), " year:" + year);
  const yearNum = parseInt(''+year);

  const retMovements = await listMixedMovementsFullByCompanyYearAndCriteria(Dependencies.getInstance().getMovementRepository(),companyId,  yearNum, criteria);
  console.log("(userMovements) retMovements: #-->: ", JSON.stringify(retMovements.type?.content?.length));
  return retMovements;
}


export async function useNearMovementsPageForMovement(companyId:string, movementId: string, amount:number, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useNearMovementsPageForMovement: " + companyId + " movementId: " + movementId + " pageNumber:" + pageNumber + "pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("movement_balance", ">", "0");

  let amountFilter;
  //console.log("(useMovement) amount: " + amount );
  //console.log("(useMovement) amount>0: " + (amount>0) );
  if(amount>0){
    amountFilter = new Filter("movement_total_amount", "<", "0");
  }else{
    amountFilter = new Filter("movement_total_amount", ">=", "0");
  }
  

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);
  arrayFilters.push(amountFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retMovements = await listNearMovementsForMovement(Dependencies.getInstance().getMovementRepository(), companyId, movementId, criteria);
  console.log("retMovements #-->: ", JSON.stringify(retMovements.type?.content?.length));  
  return retMovements;
}


export async function useNearMovementsPageForDocument(companyId:string, documentId: string, type: string, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useNearMovementsPageForDocument: " + companyId + " documentId: " + documentId + " type:" + type + " pageNumber:" + pageNumber + "pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("movement_balance", ">", "0");

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retMovements = await listNearMovementsForDocument(Dependencies.getInstance().getMovementRepository(), companyId, documentId, type, criteria);
  console.log("retMovements #-->: ", JSON.stringify(retMovements.type?.content?.length));  
  return retMovements;
}

export async function useNearMovementsPageForExpense(companyId:string, documentId: string, type: string, originalType:string, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useNearMovementsPageForExpense: " + companyId + " documentId: " + documentId + " type:" + type +  " originalType:" + originalType + " pageNumber:" + pageNumber + "pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("movement_balance", ">", "0");
  let typeExpenseFilter = new Filter("movement_total_amount", ">", "0");
  if(ExpenseDomain.OUTFLOWS.includes(originalType)){
    typeExpenseFilter = new Filter("movement_total_amount", "<", "0");
  }


  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);
  arrayFilters.push(typeExpenseFilter);


  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retMovements = await listNearMovementsForDocument(Dependencies.getInstance().getMovementRepository(), companyId, documentId, type, criteria);
  console.log("retMovements #-->: ", JSON.stringify(retMovements.type?.content?.length));  
  return retMovements;
}


export async function useClientMovementsPageForDocument(companyId:string, documentId: string, type: string, clientId:string, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useClientMovementsPageForDocument: " + companyId + " documentId: " + documentId + " type:" + type + " clientId:" + clientId +  " pageNumber:" + pageNumber + "pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("document_balance", ">", "0");

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retMovements = await listClientMovementsForDocument(Dependencies.getInstance().getMovementRepository(), companyId, documentId, type, clientId, criteria);
  console.log("(useClientMovementsPageForDocument) retMovements #-->: ", JSON.stringify(retMovements.type?.content?.length));  
  return retMovements;
  //  return new VectiResult(true, [{}]);
}


export async function useProviderMovementsPageForDocument(companyId:string, documentId: string, type: string, providerId:string, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useProviderMovementsPageForDocument: " + companyId + " documentId: " + documentId + " type:" + type + " providerId:" + providerId +  " pageNumber:" + pageNumber + "pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("document_balance", ">", "0");

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retMovements = await listProviderMovementsForDocument(Dependencies.getInstance().getMovementRepository(), companyId, documentId, type, providerId, criteria);
  console.log("(useProviderMovementsPageForDocument) retMovements #-->: ", JSON.stringify(retMovements.type?.content?.length));  
  return retMovements;
  //  return new VectiResult(true, [{}]);
}


export async function useCollaboratorMovementsPageForDocument(companyId:string, documentId: string, type: string, collaboratorId:string, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useCollaboratorMovementsPageForDocument: " + companyId + " documentId: " + documentId + " type:" + type + " collaboratorId:" + collaboratorId +  " pageNumber:" + pageNumber + "pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("document_balance", ">", "0");

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retMovements = await listCollaboratorMovementsForDocument(Dependencies.getInstance().getMovementRepository(), companyId, documentId, type, collaboratorId, criteria);
  console.log("(useProviderMovementsPageForDocument) retMovements #-->: ", JSON.stringify(retMovements.type?.content?.length));  
  return retMovements;
  //  return new VectiResult(true, [{}]);
}


export function useMovementCompanySearch(companyId: string, search: string) {
  const retMovements = listMovementsFullRepositoryByCompanyAndSearch(Dependencies.getInstance().getMovementRepository(), companyId, search);
  return retMovements;
}


export async function usePreviredMovementsPage(companyId:string, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de usePreviredMovementsPage: " + companyId + " documentId: " + " pageNumber:" + pageNumber + "pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  
  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retMovements = await listPreviredMovementsByCompany(Dependencies.getInstance().getMovementRepository(), companyId, criteria);
  console.log("(usePreviredMovementsPage) retMovements #-->: ", JSON.stringify(retMovements.type?.content?.length));  
  return retMovements;
  //  return new VectiResult(true, [{}]);
}



